import React, { useMemo } from 'react';

import { ReportingMechanics } from './section/ReportingMechanics';
import { createBankAccountsMap } from 'packages/creditAgreements/ui/creditAgreementWip/utils/createMaps';
import {
  CreditAgreement,
  CreditAgreementFullArtifactWipConfigType,
} from 'packages/creditAgreements/ui/types';

/**
 * Report-config section of a Backup Servicing (BUS) deal — renders only the
 * reporting mechanics (certificate / report configs) of the underlying artifact.
 *
 * Prop-compatible with the other artifact bodies so it drops into the shared
 * client WIP editor via its `ArtifactComponent` seam; the BUS Settings hub mounts
 * it as the "Report Config" section. Saves round-trip the whole artifact JSON, so
 * editing just this section needs no backend change.
 */
type BusReportConfigArtifactProps = {
  organizationId: string;
  creditAgreementFullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
};

export const BusReportConfigArtifact = ({
  organizationId,
  creditAgreementFullArtifact,
  wipConfig,
}: BusReportConfigArtifactProps): React.ReactElement => {
  const {
    facilityMechanics,
    reportingMechanics,
    id: creditAgreementId,
  } = creditAgreementFullArtifact;

  const bankAccounts: CreditAgreement.DomainEntity.Items.BankAccountEntity[] = useMemo(
    () => Array.from(createBankAccountsMap(facilityMechanics.parties).values()),
    [facilityMechanics],
  );

  return (
    <ReportingMechanics
      organizationId={organizationId}
      creditAgreementId={creditAgreementId}
      reportingMechanics={reportingMechanics}
      wipConfig={wipConfig}
      bankAccounts={bankAccounts}
    />
  );
};
